import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { AuthContext } from '../../providers/AuthContext';
import { getDisplayImageUrl } from '../../utils/imageUtils';

const AIProductsSection = () => {
    const { user } = useContext(AuthContext);
    const [showcaseImages, setShowcaseImages] = useState({
        futuristicAbstract: '/images/ai-placeholder-1.png',
        livingWatercolors: '/images/ai-placeholder-2.png'
    });

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await fetch('/api/settings');
                if (!response.ok) return;

                const data = await response.json();
                setShowcaseImages(prev => ({
                    ...prev,
                    ...(data?.homeImages?.aiShowcase || {})
                }));
            } catch (error) {
                console.error('Error fetching home AI images:', error);
            }
        };

        fetchSettings();
    }, []);

    return (
        <section className="ai-products-section py-5 bg-light position-relative">
            <div className="container">
                <div className="row align-items-center mb-5">
                    <div className="col-12 col-md-8">
                        <h2 className="fw-bold modern-title mb-3">
                            <span className="text-gradient">Innovación Creada por IA</span>
                        </h2>
                        <p className="text-muted fs-5">Descubrí diseños únicos generados por Inteligencia Artificial o convertí tus propias ideas en realidad al instante.</p>
                    </div>
                    <div className="col-12 col-md-4 text-md-end mt-3 mt-md-0">
                        <Link to="https://ai.rementerprises.uy/" className="btn btn-dark btn-lg rounded-pill px-4 shadow-sm fw-bold">
                            <i className="fa-solid fa-wand-magic-sparkles me-2 text-brand-green"></i> Crear con IA
                        </Link>
                    </div>
                </div>

                <div className="row g-4">
                    <div className="col-12 col-md-6 col-xl-4">
                        <div className="ai-showcase-card rounded-4 overflow-hidden position-relative shadow-sm h-100">
                            <img
                                className="ai-showcase-bg"
                                src={getDisplayImageUrl(showcaseImages.futuristicAbstract)}
                                alt="Futurismo Abstracto"
                            />
                            <div className="ai-showcase-overlay position-absolute bottom-0 w-100 p-4 text-white">
                                <span className="badge bg-white text-dark mb-2 px-3 py-2 rounded-pill fw-bold">
                                    <i className="fa-solid fa-fire text-brand-green me-2"></i> Tendencia
                                </span>
                                <h3 className="fw-bold fs-4">Futurismo Abstracto</h3>
                                <p className="mb-0 opacity-75">Diseños únicos generados con nuestra última IA de alta resolución.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-xl-4">
                        <div className="ai-showcase-card rounded-4 overflow-hidden position-relative shadow-sm h-100 mt-md-4">
                            <img
                                className="ai-showcase-bg"
                                src={getDisplayImageUrl(showcaseImages.livingWatercolors)}
                                alt="Acuarelas Vivas"
                            />
                            <div className="ai-showcase-overlay position-absolute bottom-0 w-100 p-4 text-white">
                                <span className="badge bg-white text-dark mb-2 px-3 py-2 rounded-pill fw-bold">
                                    <i className="fa-solid fa-paintbrush text-brand-green me-2"></i> Arte Digital
                                </span>
                                <h3 className="fw-bold fs-4">Acuarelas Vivas</h3>
                                <p className="mb-0 opacity-75">Estilos pintorescos adaptados perfectamente para cuadros y remeras.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-12 col-xl-4">
                        <div className="ai-info-card rounded-4 p-5 h-100 text-center d-flex flex-column justify-content-center border" style={{ background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)" }}>
                            <div className="ai-icon-pulse mx-auto mb-4">
                                <i className="fa-solid fa-microchip fa-3x text-brand-green"></i>
                            </div>
                            <h3 className="fw-bold fs-4 mb-3">Tu Propia Colección AI</h3>
                            <p className="text-muted mb-4">
                                Si alguna vez ingresaste un pedido o usaste nuestro generador, tus creaciones se guardan de forma privada.
                            </p>

                            <Link
                                to={user ? `/productoai/${user.email}` : "/user"}
                                className="btn btn-outline-brand-green btn-lg rounded-pill fw-bold w-100"
                            >
                                {user ? "Ver Mis Productos" : "Iniciar Sesión para ver mis Productos"}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AIProductsSection;
